module.exports = __webpack_public_path__ + "img/bitbox.4885c18a.png";